// _fetch.js
import { useNavigate } from "react-router-dom";

function clearSession() {
  localStorage.clear();
  document.cookie.split(";").forEach((c) => {
    document.cookie = c.replace(/^ +/, "").replace(/=.*/, `=;expires=${new Date(0).toUTCString()};path=/`);
  });
}

export default function useFetch() {
  let navigate = useNavigate();

  async function _fetch(url, obj = {}) {
    let headers = {};
    let { method = "GET", body = undefined } = obj;
    if (body) headers["Content-Type"] = "application/json";

    const res = await fetch(url, {
      headers,
      body: JSON.stringify(body),
      method,
      credentials: "include",
    });

    if (res.status === 401) {
      clearSession();
      if (window.location.pathname !== "/auth/sign-in") {
        navigate("/auth/sign-in", { replace: true });
      }
    }

    return res;
  }

  return _fetch;
}

// plain (non-hook) version for use outside components
export async function _fetch(url, obj = {}) {
  let headers = {};
  let { method = "GET", body = undefined } = obj;
  if (body) headers["Content-Type"] = "application/json";

  const res = await fetch(url, {
    headers,
    body: JSON.stringify(body),
    method,
    credentials: "include",
  });

  if (res.status === 401) {
    clearSession();
    if (window.location.pathname !== "/auth/sign-in") {
      window.location.assign("/auth/sign-in");
    }
  }

  return res;
}